import React from 'react';
import { observer } from 'mobx-react';

import { Image } from 'legacyComponents/cards/styles';
import { imageSrc } from 'apps/file/utils';
import { clientStore } from 'apps/client/app';
import { staticURL } from 'core/url';
import { conf as mainConf } from 'apps/config.yaml';

import {
  CollectionCardImageWrapper,
  GridImage,
} from 'apps/collection/views/cardImage.styles';

export const CollectionCardImage = observer(({ images }) => {
  if (images.length === 0) {
    return (
      <CollectionCardImageWrapper>
        <Image
          src={staticURL(
            mainConf.imageDefaults.project,
            '',
            mainConf.imgSizes.project.card,
          )}
        />
      </CollectionCardImageWrapper>
    );
  }

  if (images.length < 4 || clientStore.activeBreakPoint === 'xs') {
    return (
      <CollectionCardImageWrapper>
        <Image
          src={imageSrc(images.apps[0], '', mainConf.imgSizes.project.card)}
        />
      </CollectionCardImageWrapper>
    );
  }

  const collageImages = images.map(image => (
    <GridImage
      key={image.id}
      src={imageSrc(image, '', mainConf.imgSizes.project.card)}
    />
  ));

  return (
    <CollectionCardImageWrapper>{collageImages}</CollectionCardImageWrapper>
  );
});
